import React from "react";
import { Box } from "@mui/material";
import {
  MyLeaveAdminSettingsTypeFilterCard,
  MyLeaveEmailCard,
  MyLeaveGeneralSettingsCard,
} from "my-leave/components";
import { myLeaveAdminSettingsPageMenuDef } from "my-leave/configs/menu-defs";
import { OcPageSideMenu, OcPageTransition } from "oc/components";
import { useOcIsMobile, useOcPageSideMenu } from "oc/hooks";

export const MyLeaveAdminSettingsPage = () => {
  const stateId = "myLeaveSettingsPageMenuActiveItem";
  const { state: selectedItem } = useOcPageSideMenu({
    id: stateId,
    initialValue: myLeaveAdminSettingsPageMenuDef[0].id,
  });

  const isMobile = useOcIsMobile();

  return (
    <OcPageTransition>
      <Box>
        <Box
          height="80px"
          style={{ backgroundColor: "#cc0033" }}
          display="flex"
          flexDirection="row"
          alignItems="center"
          paddingLeft="14px"
        >
          <Box style={{ color: "white", fontSize: "24px" }}>MyLeave</Box>
        </Box>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          <OcPageSideMenu
            stateId={stateId}
            menuDef={myLeaveAdminSettingsPageMenuDef}
          />
          <Box flexGrow={1} padding={isMobile ? "16px 0px" : "16px"}>
            {selectedItem === "generalSettings" && (
              <MyLeaveGeneralSettingsCard isMobile={isMobile} />
            )}
            {selectedItem === "leaveFilters" && (
              <MyLeaveAdminSettingsTypeFilterCard />
            )}
            {selectedItem === "administrativeEmail" && (
              <MyLeaveEmailCard
                type="administrativeEmail"
                isMobile={isMobile}
              />
            )}
            {selectedItem === "subsequentRequests" && (
              <MyLeaveEmailCard type="payrollEmail" isMobile={isMobile} />
            )}
          </Box>
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyLeaveAdminSettingsPage;
